import type { VariablesOf } from "@graphql-typed-document-node/core";
import { safe } from "pb.safe";

import {
	$,
	mutation,
} from "../../../../../schema.dev-sdk-api-appsync.generated";
import type { ApiClient } from "../../shared/shared/api-client";

export function sendPayByLink({
	apiClient,
	...variables
}: {
	apiClient: ApiClient;
} & VariablesOf<typeof sendPayByLink.gql.createAndSendPayByLink>) {
	return safe(() =>
		apiClient.request(sendPayByLink.gql.createAndSendPayByLink, variables),
	);
}

sendPayByLink.gql = {
	createAndSendPayByLink: mutation("createAndSendPayByLink", (q) => [
		q.createAndSendPayByLink(
			{
				deviceUuid: $("deviceId"),
				entityUuid: $("entityId"),
				input: {
					amount: $("amount"),
					contact: {
						contactMethod: $("targetMethod"),
						contactDetails: $("targetHandle"),
					},
					reference: $("reference"),
				},
			},
			(q) => [q.id, q.reference],
		),
	]),
};
